import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const ResendEnrollmentInviteMutation = graphql.persisted(
  "ResendEnrollmentInvite",
  graphql(`
    mutation ResendEnrollmentInvite($input: ResendEnrollmentInviteInput!) {
      resendEnrollmentInvite(input: $input) {
        result { familyEnrollmentId status reason }
        errors
      }
    }
  `)
);

export { ResendEnrollmentInviteMutation };

export function useResendEnrollmentInvite() {
  return useMutation(ResendEnrollmentInviteMutation);
}
